import { invoiceSharePath } from '@goyone/shared';
import { currentTenant } from './api';
import { isLocalHost } from './site';

/**
 * رابطُ الفاتورة للعميل — مطلقًا بنطاق الشركة: «https://sunmed.goyone.com/v/invoice/…».
 *
 * الرمزُ من الخادم (صفوفُ كشف الحساب، وصفحةُ الفاتورة)، والنطاقُ من الصفحة:
 * الشركةُ تُعرف منه حين يُفتح الرابط. وعلى localhost لا نطاقَ فرعيًّا،
 * فتُلحق الشركةُ بالرابط (`?tenant=`) ليعمل في التطوير كما يعمل في الإنتاج.
 */
export function invoiceShareUrl(token: string): string {
  const url = `${window.location.origin}${invoiceSharePath(token)}`;
  const tenant = isLocalHost() ? currentTenant() : null;
  return tenant ? `${url}?tenant=${encodeURIComponent(tenant)}` : url;
}

/** ينسخ رابطَ الفاتورة للعميل، وإن مُنعت الحافظةُ عرضه ليُنسخ باليد. */
export async function copyInvoiceLink(token: string, toast: (text: string) => void): Promise<void> {
  const url = invoiceShareUrl(token);
  try {
    await navigator.clipboard.writeText(url);
    toast('نُسخ رابط الفاتورة للعميل — يفتحها كاملةً بلا حساب.');
  } catch {
    window.prompt('انسخ رابط الفاتورة:', url);
  }
}
